var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2073_72",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2073_72",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACaUlEQVR4nO2dO4sUQRRG20D/zKoIRqKBaCabDphPfV8PmCliIjiZsqBgIIYqPhJjM1ND/QeCrG7gIzFUF1YaR1ilXbed7ltO1zlQYc/cOtzpvvXqqSoAAAAAAAD4f0kpHZP00PaW7a+S3tm+P5vNDueObTTYvmR72/bO703SN9sXcse48kiatwluaVdzx1qC5B1kx0lGdqBkZAdKRnagZGQHSv7ZKP0iRDd1dkpp7ZcvKx0Nl9X3cvetCNmSNnP3qxTZX3L3qRTZb3P3pwjZkh5UpYmTNO96zZKit6fT6dGqFLRLWLDsi1UpqEWUpBtdPsP2lX+QfK0qBe2RjQPLRrKHl41kD5/ZSPbwspHs4WUj2d0GF51Lv67XrDTqccjcNbOLQcPMuCE7aA4Z2RGSkR0ouXjZCpRcrGxlkLxo1MlGMpm8UojbBZJHgchkJI8CkclIHgUik5E8CsjkAJAcAJIDQHIASA4AyQEgOQAkB4DkAGwfTCkdt33W9uXm4EzQYuq8KhnbJ5AclOGL1+OQyUMj6RNbAgKQ9Jp9FwHYfsmDLwBJz9lBFICkp2zTCkDSTerkAFJKZxiMLIntI/sZldV1fVrShu3Hkp7ZfiHpVVOR7FX+FT/i2yX6eh9CUkprkj4juZ0Dtt/0lX22b5HJ7WJO9flTl3Se20W7mLt9Hkvwjxm/cnba73eyyPbHPh9ik8nk0DDRrjAppXUO3AQg6QmnmwKw/YGjZAEs/mTgb8tLm7ZvN0tbETGNkqay+IPg5gF5p67rk02dnTvOlaepEBaytyS9t/2orutzTTWSOzYAAAAAAAColuM7f2f2/PUaACAAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.912a2ed43f162ec65cbf4fd933b96aca.svg";
export { ForwardRef as ReactComponent };